module.exports = __webpack_public_path__ + "static/media/tables.5ecee640.jpg";